import { DateStyles } from 'components/DatePickerStyles/Styles/style'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import { FormItem } from 'components/UIComponents/FormStyles'
import CalendarIcon from 'components/icons/CalendarIcon'
import React from 'react'
import styled from 'styled-components'

const StyledFlex = styled(Flex)`
  width: ${props => props.width};
  position: relative;
  .ant-picker-dropdown {
    top: ${props => `${props.setStartPosition}!important`};
  }
`

const DatePicker = ({
  suffixIcon = <CalendarIcon />,
  id,
  width = '50%',
  name = 'date',
  rules,
  color = '#010E30',
  placeholder = 'DD/MM/YYYY',
  dateFormat = 'DD/MM/YYYY',
  label,
  isEditable = false,
  getPopupContainer,
  setStartPosition,
  ...props
}) => {
  return (
    <StyledFlex
      column
      width={width}
      id={getPopupContainer ?? 'datePicker'}
      setStartPosition={setStartPosition}
    >
      <Label>{label}</Label>
      <FormItem name={name} rules={rules} width={'100%'}>
        <DateStyles
          suffixIcon={suffixIcon}
          id={id}
          width={'100%'}
          color={color}
          opacity="1"
          placeholder={placeholder}
          format={dateFormat}
          getPopupContainer={() =>
            document.getElementById(getPopupContainer ?? `datePicker`)
          }
          {...props}
          disabled={isEditable}
        />
      </FormItem>
    </StyledFlex>
  )
}

export default DatePicker
